// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shipment-progress-bar[data-v-63041cd4]{background-color:#fff}.shipment-progress-step[data-v-63041cd4]{color:#36134a!important}@media(max-width:599px){.shipment-progress-step[data-v-63041cd4]{font-size:12px;padding:5px 15px}}.shipment-progress-step[data-v-63041cd4]:after,.shipment-progress-step[data-v-63041cd4]:before{background-color:#eadef7}", ""]);
// Exports
module.exports = exports;
